// extracted by mini-css-extract-plugin
export default {"root":"qczk6iXIik","root_active":"YPgxWPbEE9","content":"NYYj4hHMn2","avatar":"Ho83_DfNyl","info":"ypAj9Wjk5e","name":"rDjuenJ5G9","tags":"CouDD1gE5B","footer":"_1sn9aafFA"};